import {Field} from "formik";
import React from "react";

export default function CampoInputTextarea({
                                               elemento,
                                               modifica,
                                               disabled,
                                               fieldRef,
                                               valore,
                                               onBlurCampo,
                                               onFocusCampo,
                                               onChangeCampo,
                                               onValidate,
                                           }) {

    return (
        <Field
            as={"textarea"}
            id={elemento.id_kpi_elemento}
            name={elemento.cella}
            className={"sost-input-tabella-kpi" + (modifica === true ? ' sost-input-tabella-kpi--mod' : '')}
            disabled={disabled}
            placeholder={elemento.placeholder}
            innerRef={fieldRef}
            onFocus={onFocusCampo}
            onChange={onChangeCampo}
            onBlur={onBlurCampo}
            validate={onValidate}
        >{valore}</Field>
    );
}